
import SimpleEvent from './../../zviz2/zviz/event';
import {scrollTo} from './../../tools';


class Video{

    constructor(settings={}, items=[]){

        this.events = [];
        this.closeEvents = {};
        this.curCols = 0;
        this.curTheme = null;
        this.curEvents = []
        this.scollingCycle = null;
        this.language = settings.language || 'english';

        // shuffle
        for (let i = items.length; i; i--) {
            let j = Math.floor(Math.random() * i);
            [items[i - 1], items[j]] = [items[j], items[i - 1]];
        }
        this.items = items;

        this.events.push(new SimpleEvent(window, 'resize', [this, this.setItems]));
        let elm = document.getElementById('projectThemeSelect');
        this.events.push(new SimpleEvent(elm, 'change', [this, this.setItems]));
        this.setItems();


    }

    setItems(){
        let cols = window.innerWidth >= 700? 3: 1;
        let s = document.getElementById('projectThemeSelect');
        let theme = s.value || null;
        if(theme != this.curTheme || cols != this.curCols){
            clearInterval(this.timerId);
            this.curTheme = theme;
            this.curCols = cols;
            this.closeAll();
            for(let i = 0; i < this.curEvents.length; i++){
                this.curEvents[i].remove();
            }
            let elm = document.getElementById('projectsContainer');
            while(elm.childNodes.length>0){
                elm.removeChild(elm.childNodes[0]);
            }
            let i = 0;
            let row = null;
            for(let item of this.items){
                if(row == null){
                    row = document.createElement('div');
                    row.className = 'threeCols';
                }
                if(theme == null || theme == item.theme){
                    row.innerHTML += item.html;
                    i++;
                    if(i == cols){
                        elm.appendChild(row);
                        row = null;
                        i = 0;
                    }
                }
            }
            if(row){
                elm.appendChild(row);
            }
            let videos = document.getElementsByClassName('video');
            for(let i = 0; i < videos.length; i++){
                for(let c = 0; c < videos[i].childNodes.length; c++){
                    let v = videos[i].childNodes[c];
                    if(v.tagName && v.tagName.toLowerCase() == 'a'){
                        this.curEvents.push(new SimpleEvent(v, 'click', [this, this.openProject]));
                    }
                }
            }

            let links = document.getElementsByClassName('readmore');
            for(let i = 0; i < links.length; i++){
                let v = links[i];
                this.curEvents.push(new SimpleEvent(v, 'click', [this, this.openProject]));
            }

            if(cols == 3){
                this.setColHeights();
                this.timerId = setInterval(this.setColHeights, 1000);
            }
        }
    }

    setColHeights(){
        let rows = document.getElementsByClassName('threeCols');
        for(let row of rows){
            let v = row.getElementsByClassName('videoPlayer');
            if(v.length == 0){
                let p = row.getElementsByClassName('project');
                for(let proj of p){
                    proj.style.minHeight = (row.clientHeight - 69) + 'px';
                }
            }
        }
    }


    openProject(event){
        event.preventDefault();

        let elms = document.getElementsByClassName('closeVideo');
        for(let e of elms){
            this.closeVideo(e);
        }

        let v = event.currentTarget;
        let url = v.getAttribute('href');
        let p = v.parentNode;
        while(p.parentNode && p.className != 'project'){
            p = p.parentNode;
        }
        let parent = p.parentNode.parentNode;
        let width = parent.clientWidth - 80;
        if(window.innerWidth < 700){
            width = parent.clientWidth - 20;
        }
        let height = Math.min(0.6 * width, 550);
        
        let embed = '';
        if(url != '#'){
            // youtube
            embed = '<iframe width="' + width + '" height="'+height+'" src="' + url + '" frameborder="0" allowfullscreen></iframe>';
            if(v.parentNode.className.indexOf('vimeo') > -1){
                // vimeo
                embed = '<iframe src="' + url + '" width="' + width + '" height="'+height+'" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>';
            }
        }

        let t = p.getElementsByClassName('fullText');
        let text = '';
        if(t && t[0]){
            text = '<p>' + t[0].innerHTML + '</p>';
        }

        let h = p.getElementsByClassName('projectTitle');
        let header = '';
        if(t && t[0]){
            header = '<h2>' + h[0].innerHTML + '</h2>';
        }

        zolabo.trackEvent('projects', 'open project', h[0].innerHTML);

        let div = document.createElement('div');
        div.className = 'videoPlayer';
        div.style.opacity = 0;
        div.innerHTML = embed + header + text;

        let id = Math.round(999999*Math.random());
        let a = document.createElement('a');
        a.id = id;
        a.className = 'closeVideo';
        a.setAttribute('href', '#');
        a.textContent = this.language =='english'? 'Close': 'Sluiten';

        div.style.borderBottom = '3px solid ' + p.style.borderColor;

        div.appendChild(a);

        parent.appendChild(div);

        
        this.closeEvents[id] = new SimpleEvent(a, 'click', [this, this.onClose]);

        
        this.scollingCycle = scrollTo(div, 500, true, 0);
        this.scollingCycle.start();

        p.style.paddingBottom = '35px';
        p.style.borderWidth = '6px 0px 0px 0px';

        // div.style.opacity = 1;
        setTimeout(function(){  div.style.opacity = 1; }, 100);
    }

    onClose(event){
        event.preventDefault();
        let elm = event.currentTarget;
        this.closeVideo(elm);
    }

    closeAll(){
        for(let id of Object.keys(this.closeEvents)){
            let elm = document.getElementById(id);
            if(elm){
                this.closeVideo(elm);
            }
        }
    }

    closeVideo(elm){
        let id = elm.id;
        if(this.closeEvents[id]){
            this.closeEvents[id].remove();
            delete this.closeEvents[id];
        }else{
            console.warn('could not find event');
        }
        if(this.scollingCycle){
            this.scollingCycle.remove();
        }

        let p = elm.parentNode;
        let e = p.parentNode.getElementsByClassName('project');
        for(let el of e){
            el.style.paddingBottom = '5px';
            el.style.borderWidth = '6px 0px 3px 0px';
        }
        p.parentNode.removeChild(p);

        
        // let player = p.getElementsByClassName('videoPlayer');
        // if(p.className == 'indicatorVisual'){
        //     p.style.paddingTop = '0px';
        // }
        // if(player[0]){
        //     player[0].style.opacity = 0;
        // }
        // setTimeout(function(){
        //     if(player[0]){
        //         p.removeChild(player[0]);
        //     }
        //     p.style.minHeight = 'auto';
        // }, 300);

    }


    remove(){
        clearInterval(this.timerId);
        this.closeAll();
        for(let i = 0; i < this.events.length; i++){
            this.events[i].remove();
        }
        for(let i = 0; i < this.curEvents.length; i++){
            this.curEvents[i].remove();
        }
        if(this.scollingCycle){
            this.scollingCycle.remove();
        }
        this.events = [];
    }

}

export default Video;